import i18n, { i18n as i18nType } from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-locize-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

const createI18nInstance = (locizeOptions?: {
    projectId: string
    apiKey: string
    version: string
    referenceLng: string
}): i18nType => {
    i18n.use(Backend)
        .use(LanguageDetector)
        .use(initReactI18next)
        .init(
            {
                backend: {
                    projectId:
                        locizeOptions?.projectId ||
                        (process.env.REACT_APP_LOCIZE_PROJECTID as string),
                    apiKey:
                        locizeOptions?.apiKey ||
                        (process.env.REACT_APP_LOCIZE_APIKEY as string),
                    version:
                        locizeOptions?.version ||
                        process.env.REACT_APP_LOCIZE_BRANCH,
                    referenceLng: locizeOptions?.referenceLng || 'da-DK',
                    reloadInterval: false,
                    debug: true,
                } as Backend.BackendOptions,
                debug: false,
                fallbackLng: ['da-DK', 'en-GB'],
                defaultNS: 'bookingflow',
                ns: ['common', 'bookingflow'],
                interpolation: {
                    escapeValue: false,
                },
                react: {
                    useSuspense: false,
                    bindI18n: 'languageChanged editorSaved',
                },
            },
            (err, t) => {
                if (err) return console.log('something went wrong loading', err)
                t('key') // -> same as i18next.t
            }
        )
    return i18n
}

export default createI18nInstance
